import React, { useState, useContext, useEffect, useRef } from "react";
import mondrian from "core/config/theme";
import styled from "styled-components";
import AccessibilitySkipLinks from "./AccessibilitySkipLinks";
import Loading from "components/Loading";
import Cookies from "universal-cookie";
import { getDomainName } from "core/Utils";
import { Button, Link, useTab, useTheme } from "mondrian-react";
import { loadDynamicScripts } from "core/Utils/Utils";
import { store } from "store.js";
import endSession from "core/api/endSession/endSession";
import TextSizeModal from "./TextSizeModal";
const cookies = new Cookies();
export const Container = styled.div`
  margin-bottom: ${mondrian.spacingStackMd};
`;

export default function SimpleHeader() {
  const [isLoading, setIsLoading] = useState(false);
  const globalState = useContext(store);

  const profileMenuRef = useRef();

  useState(useTab);



    const logoutFn = async function (ev) {
      setIsLoading(true);
      endSession();
     
      ev.preventDefault();
       cookies.remove("accesstoken", {
        domain: getDomainName(window.location.hostname),
      });
      document.location.href = process.env.REACT_APP_END_SESSION_REDIRECT ;
      setIsLoading(false);
    };
  const [mobileActive, setMobileActive] = useState(false);
  const [contraste, setContraste] = useState(false);
  const { toggleTheme } = useTheme();
  const { state, dispatch } = globalState;
  const { contrast } = state;
  function handleBlur(e) {
    if (e && e.relatedTarget) {
      e.relatedTarget.click();
    }
    setMobileActive(false);
  }
  function handleContrasteClick() {
    setContraste((current) => !current);
    toggleTheme();
  }
  useEffect(
    function () {
      let auxContraste = contrast === undefined ? false : contraste;
      dispatch({
        type: "SET_CONTRASTE",
        payload: !auxContraste,
      });
    },
    [contrast, contraste, dispatch]
  );

  const [pluginIsLoaded, LoadPlugin] = useState(false);
  //if (disableRuleContent()) return null;
  function loadHandTalk(cb) {
    loadDynamicScripts
      .url("https://plugin.handtalk.me/web/latest/handtalk.min.js")
      .then(function () {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "handTalk";
        // eslint-disable-next-line
        var ht = new HT({ token: `${process.env.REACT_APP_HANDTALK_TOKEN}` });
        document.body.appendChild(script);
      });
  }

  function handleLibrasClick() {
    if (pluginIsLoaded) return;
    LoadPlugin(true);
    loadHandTalk();
  }
  return (
    <>
      <Loading isLoading={isLoading} />
      <Container className="cred-header">
        <header className="cred-Header" id="mdn-Header" role="banner">
          <AccessibilitySkipLinks />
          <div className="cred-HeaderTop">
            <div className="cred-HeaderContainer">
              <nav className="cred-HeaderTopContent">
                <ul className="cred-HeaderTopList"></ul>
                <ul className="cred-HeaderTopList cred-HeaderTopList--right">
                  <li className="cred-HeaderTopItem">
                    <i className="mdn-Icon-pcd mdn-Icon--sm cred-HeaderTopLeadingIcon"></i>
                    <Link
                      inline
                      inverse
                      href="https://www.claro.com.br/institucional/regulatorio/acessibilidade"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cred-HeaderTopAction cred-HeaderTopAction--withLeadingIcon"
                      tabIndex="4"
                    >
                      Acessibilidade
                    </Link>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <i className="mdn-Icon-alto-contraste mdn-Icon--sm cred-HeaderTopLeadingIcon"></i>
                    <Button
                      type="button"
                      className="cred-HeaderTopAction cred-HeaderTopAction--withLeadingIcon"
                      onClick={handleContrasteClick}
                      tabIndex="5"
                    >
                      Contraste
                    </Button>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <Button
                      type="button"
                      className="cred-HeaderTopAction btn-handTalk"
                      onClick={handleLibrasClick}
                      tabIndex="6"
                    >
                      <i className="mdn-Icon-libras mdn-Icon--md"></i>
                    </Button>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <TextSizeModal
                      triggerClassName="cred-HeaderTopAction"
                      wrapperClassName="cred-HeaderTextSize"
                    />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="cred-HeaderContainer cred-HeaderMain">
            <nav className="cred-HeaderMainContent">
              <div className="cred-HeaderMainSide">
                <img
                  className="cred-SimpleHeaderLogo"
                  src="https://mondrian.claro.com.br/brands/inverse/claro.svg"
                  alt="Logo da Claro"
                />
              </div>
            </nav>
          </div>
        </header>
      </Container>
    </>
  );
}
